var Item, addTag, encodeNameForAttributeName, encodeTag, encodesAttributeName, parseTags, removeTag, reservedTags, syncTagAttributeToItemBody, tagRange, tagRegex, tagRegexString, tagValueRegex, tagValueRegexString, tagWordCharsRegex, tagWordRegexString, tagWordStartCharsRegex, trailingTagsRegex;

Item = require('../../item');

tagWordStartCharsRegex = /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;

tagWordCharsRegex = /[\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]/;

tagWordRegexString = "(?:" + tagWordStartCharsRegex.source + "|" + tagWordCharsRegex.source + ")*";

tagValueRegex = /\(((?:\\\(|\\\)|[^()])*)\)/;

tagValueRegexString = tagValueRegex.source;

tagRegexString = "(^|\\s+)@(" + tagWordRegexString + ")(?:" + tagValueRegexString + ")?(?=\\s|$)";

tagRegex = new RegExp(tagRegexString, 'g');

trailingTagsRegex = new RegExp("(" + tagRegexString + ")+\\s*$", 'g');

reservedTags = {
  'data-id': true,
  'data-text': true,
  'data-type': true
};

tagRange = function(text, tag) {
  var result;
  result = void 0;
  tag = 'data-' + tag;
  parseTags(text, function(eachTag, eachValue, eachMatch) {
    if (tag === eachTag) {
      return result = {
        location: eachMatch.index,
        length: eachMatch[0].length
      };
    }
  });
  return result;
};

encodeTag = function(tag, value) {
  if (value) {
    value = Item.objectToAttributeValueString(value);
    value = value.replace(/\)/g, '\\)');
    value = value.replace(/\(/g, '\\(');
    return "@" + tag + "(" + value + ")";
  } else {
    return "@" + tag;
  }
};

addTag = function(item, tag, value) {
  var range, tagString;
  tagString = encodeTag(tag, value);
  range = tagRange(item.bodyString, tag);
  if (!range) {
    range = {
      location: item.bodyString.length,
      length: 0
    };
  }
  if (range.location > 0 && !/\s+$/.test(item.bodyString)) {
    tagString = ' ' + tagString;
  }
  return item.replaceBodyRange(range.location, range.length, tagString);
};

removeTag = function(item, tag) {
  var range;
  if (range = tagRange(item.bodyString, tag)) {
    return item.replaceBodyRange(range.location, range.length, '');
  }
};

parseTags = function(text, callback) {
  var foundTag, leadingSpace, match, ref, tag, tags, trailingMatch, value;
  tags = {};
  if (text.indexOf('@') !== -1) {
    foundTag = false;
    while (match = tagRegex.exec(text)) {
      foundTag = true;
      leadingSpace = match[1];
      tag = 'data-' + match[2];
      value = (ref = match[3]) != null ? ref : '';
      if ((tags[tag] == null) && encodesAttributeName(tag)) {
        value = value.replace(/\\\)/g, ')');
        value = value.replace(/\\\(/g, '(');
        tags[tag] = value;
        if (callback) {
          callback(tag, value, match);
        }
      }
    }
    if (foundTag) {
      trailingMatch = text.match(trailingTagsRegex);
    }
  }
  return {
    tags: tags,
    trailingMatch: trailingMatch
  };
};

syncTagAttributeToItemBody = function(item, attributeName, value) {
  var tagName;
  if (tagName = encodeNameForAttributeName(attributeName)) {
    if (value != null) {
      return addTag(item, tagName, value);
    } else {
      return removeTag(item, tagName);
    }
  }
};

encodesAttributeName = function(attributeName) {
  return !reservedTags[attributeName] && (attributeName.indexOf('data-') === 0);
};

encodeNameForAttributeName = function(attributeName) {
  if (encodesAttributeName(attributeName)) {
    return attributeName.substr(5);
  } else {
    return null;
  }
};

module.exports = {
  syncTagAttributeToItemBody: syncTagAttributeToItemBody,
  encodeNameForAttributeName: encodeNameForAttributeName,
  encodesAttributeName: encodesAttributeName,
  tagRegex: tagRegex,
  tagRange: tagRange,
  encodeTag: encodeTag,
  parseTags: parseTags
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/taskpaper/tags.js
 ** module id = 197
 ** module chunks = 0
 **/